/**
 * Microsoft Clarity — inicialização condicional (env-gate).
 *
 * Helper framework-agnostic usado pelos apps web Vite (web-admin, web-partner).
 * Se `projectId` não estiver definido, é no-op: o Clarity só carrega quando a
 * env var correspondente (`VITE_CLARITY_PROJECT_ID`) está setada no ambiente
 * de deploy. Cada app usa o seu próprio project ID.
 *
 * Atenção LGPD: o Clarity grava sessão e usa cookies de rastreamento
 * (_clck/_clsk). Em superfícies autenticadas (admin/partner) que exibem dados
 * de clientes, placas e OS, configure o masking de texto ("Mask all text") no
 * painel do Clarity para não capturar conteúdo sensível.
 */

type ClarityQueue = ((...args: unknown[]) => void) & { q?: unknown[][] };

declare global {
  interface Window {
    clarity?: ClarityQueue;
  }
}

export function initClarity(projectId?: string): void {
  if (!projectId) return;
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.clarity) return; // já inicializado

  const clarity: ClarityQueue = function clarityStub(...args: unknown[]): void {
    (clarity.q = clarity.q ?? []).push(args);
  };
  window.clarity = clarity;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${projectId}`;

  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }
}
